const matrices = document.querySelectorAll('.block-taille.matrice');

if (matrices.length > 0) {
  for (let i = 0; i < matrices.length; i++) {
    console.log(matrices[i].parentNode);
    const overlay = matrices[i].querySelector('.overlay');
    overlay.addEventListener('click', () => {
      console.log('overlay click');
      const popup = overlay.parentNode.querySelector('.popup-finitions');

      popup.classList.remove('is-hidden');

      popup.addEventListener('click', e => {
        e.stopPropagation();
        console.log('popup click');
        popup.classList.add('is-hidden');
      });
    });
  }
}
